<template>
  <div>
    <q-dialog :visible="isVisible" :title="title" width="800px" :innerScroll="false" :showFooter="false" @close="onCancel">
      <div v-loading="loading" element-loading-text="数据加载中">
        <el-table stripe v-loading="loading" ref="tableRef" border highlight-current-row :data="tableData" :height="400">
          <el-table-column prop="prizeType" label="奖品类型" align="center" width="80"></el-table-column>
          <el-table-column prop="prizeName" label="名称" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="createdTime" label="获奖时间" align="center" width="140"></el-table-column>
          <el-table-column prop="prizeCount" label="数量" align="center" width="50"></el-table-column>
          <el-table-column prop="receiveMethod" label="领奖方式" show-overflow-tooltip width="80"></el-table-column>
          <el-table-column prop="awardCondition" label="获奖方式" align="center" width="80"></el-table-column>
        </el-table>
        <div style="text-align: right">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onNumChange"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
          >
          </el-pagination>
        </div>
        <div style="text-align: center; margin-top: 20px">
          <el-button @click="onCancel" size="medium">关 闭</el-button>
        </div>
      </div>
    </q-dialog>
  </div>
</template>

<script>
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    isCountMoneyDialog: {
      type: Boolean,
      default: false,
    },
    activityId: [Number,String],
    participationId: [Number,String]
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.isCountMoneyDialog;
      },
      set(val) {
        this.$emit("update:isCountMoneyDialog", val);
      },
    },
    title() {
      return "奖品详情";
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      searchForm: {},
    };
  },
  watch: {
    participationId: {
      handler(newVal) {
        console.log(newVal)
        this.init()
      }
    }
  },
  mounted() {
    // this.init()
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    init() {
      this.loading = true;
      let data = {
        filterData: {
          activityId: this.activityId,
          participationId: this.participationId
        },
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$api.ActivityManagement
        .getCountMoneyActivityWinAwards(data)
          .then((res) => {
            this.tableData = res.data.list
            this.total = res.data.total
          })
          .finally((res) => {
            this.loading = false;
          });
    },
    onSearch() {
      this.pageNum = 1
      this.init()
    },
    resetSearchForm() {
      this.pageSize = 10
      this.$refs.searchForm.resetFields();
      this.onSearch();
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.init();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.init();
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-form-item {
  margin-bottom: 10px;
}
</style>
